
<!--=============== Banner start ==================-->
<section>

    <div id="main-wrapper" style="text-align: left">
        <div class="site-wrapper-reveal">
            <div class="position-relative w-100">
                <div class="d-flex align-items-left w-100 ">
                    <img src="../../../assets/images/banners/miteventspage.png"
                        class="img img-responsive w-100 h-100 d-none d-md-block" width="100%" alt="banners" />
                    <img src="../../../assets/images/banners/miteventimage.jpg"
                 
                        class="img img-responsive d-block d-md-none" width="100%" alt="banners" />
                    <div class="position-absolute w-100 home-banner">
                        <div class="row h-100 w-100">
                            <div class="col-8 col-md-4 col-sm-6 banner-section">
                                <div class="align-items-center global_title global_banner_title title_banner_content">
                                    <span> Maganti IT Meetups</span>
                                </div>
                                <div class="global_sub_titles global_banner_subtitle mt-3">
                                    <span>We're passionate about moving fast, bringing real-world change, and building
                                        dynamic teams together with the power of shared knowledge and innovation.</span>
                                </div>

                                <div class="col pt-lg-3 mt-4 mt-lg-3">
                                    <a href="contact" class="global_button   text-left col  text-white white_button">
                                        <div class="dub-arrow">
                                            <img src="../../../assets/images/button/arrowWhite.png" alt="banners" />
                                        </div>
                                        TALK TO AN EXPERT
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>

<!--==================== Banner end ===================-->


<!-- =============== meet experts section starts ================== -->
<section id="formContainer">
    <div class="container">
        <div class="experts">
            <div class="row">
                <div class="col-md-6 col-sm-12">
                    <div class="application_content_service global_section_header mt-5">Meetups: A Hub for Creative Thinking</div>
                    <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5">
                        <p><b>Maganti IT Meetups offer opportunities to network, share knowledge, innovate, and make
                                great things happen.
                                Each month, we're joined by industry experts and thought leaders right here on our
                                premises, ready to share
                                their insights with our team and aspiring professionals from across the city. Curious
                                about what's happening next?
                                Subscribe and stay in the loop with all our latest and upcoming events.
                            </b>
                        </p>
                    </div>
                </div>

                <div class="col-sm-12 col-md-6 col-lg-5" id='sectionOne' style="margin-top:50px">
                    <div class="border border-1 intern_forDiv">
                        <div class=" text-center" style="color:#182357; font-size:23px;">
                            <b>SUBSCRIBE NOW</b>
                        </div>
                        <div class="resumeUploadPopUp" style="display: none" id="eventregister">
                            <h1>Thank You!</h1>
                            <p>We have received your request, Our team will reach you soon</p>
                        </div>

                        <form [formGroup]="subscribeForm" (ngSubmit)="onSubmit()">
                            <div>
                                <input type="text" class="form-control my-4" name="subscribeName"
                                    style="border:1px solid black;border-radius: 10px;height: 50px"formControlName="subscribeName"
                                    id="inputRegistartionName" placeholder="Name*" autocomplete="off">
                                    <div *ngIf="subscribeForm.get('subscribeName')?.invalid && subscribeForm.get('subscribeName')?.touched" id="subscribe_NameError" style="font-size: 13px;color: #c02b2b;font-style: italic;font-weight: 500;display: flex;">{{subscribeNameError }}</div>
                            </div>
                            <div>
                                <input type="email" class="form-control my-4" name="subscribeEmail"
                                    style="border:1px solid black;border-radius: 10px;height: 50px"formControlName="subscribeEmail"
                                    id="inputRegisterEmail" placeholder="E-Mail*" autocomplete="off" required>
                                <div *ngIf="subscribeForm.get('subscribeEmail')?.invalid && subscribeForm.get('subscribeEmail')?.touched" id="subscribe_EmailError" style="font-size: 13px;color: #c02b2b;font-style: italic;font-weight: 500;display: flex;">{{subscribeEmailError }}</div>
                            </div>

                            <div class="d-grid" style="height:50px; background-color:#8522CF;  border-radius: 10px">
                                <button type="submit" class="btn btn-lg" id="registerbtn"
                                    style="height:50px; color:#fff !important; font-weight:400;">
                                    SUBMIT YOUR DETAILS
                                </button>
                            </div>
                        </form>
                        <div *ngIf="showSuccessPopup" class="alert alert-success mt-3">
                            the form has been submitted suceessfully
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</section>
<!-- =============== meet experts section starts ================== -->




<!--====== maturing section  Start ======-->
<section>
    <div class="maturing">
        <div id="operations">
            <div class="container-fluid">
                <div class="row">
                    <div class="col-lg-12">
                        <div class="text-center application_content_service global_section_header mt-2">It's all about
                            having a good time <br> while doing great things together</div>
                    </div>
                    <div class="text-center insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-2">
                        <p>Meetup fosters community and self-improvement by uniting individuals through <br>
                                activities and shared interests, promoting discovery, learning, and personal growth.
                        </p>
                    </div>
                </div>
            </div>

            <div class="row " style="margin-top:35px">
                <div class="col-lg-4 col-md-4 col-sm-12 text-center  p-2 mb-4" >
                    <img class="img-fulid" src="../../../assets/images/mit-eventspage/Diverse Niches for everyone.png" alt="banners">
                    <h4>Diverse Niches for everyone</h4>
                    <p><b>We're in for anything and everything- whether it's code, creative writing, donation or a game
                            of cricket.</b></p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 text-center  p-2 mb-4">
                    <img class="img-fulid" src="../../../assets/images/mit-eventspage/Knowledge Sharing and Learning.png" alt="banners">
                    <h4>Knowledge Sharing and Learning</h4>
                    <p><b>Platform for employees to share their knowledge, experiences, and expertise, facilitating
                            professional growth and development.</b></p>
                </div>
                <div class="col-lg-4 col-md-4 col-sm-12 text-center  p-2 mb-4">
                    <img class="img-fulid" src="../../../assets/images/mit-eventspage/Emerging and Upcoming.png" alt="banners">
                    <h4>Emerging and Upcoming</h4>
                    <p><b>Gain insight into emerging strategies, the latest innovations and best practices to accelerate
                            your career trajectory.</b></p>
                </div>
            </div>
        </div>
    </div>
</section>
<!--====== maturing section End ======-->




<!--====== Our-Activity section  Start ======-->
<section class="Our-Activity">

    <div id="main-wrapper">
        <div class="site-wrapper-reveal">
            <div class="projects-wrapper projects-masonary-wrapper">
                <div class="events">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="text-center application_content_service global_section_header mt-2">Our Activity :
                                    Featured Events and Donations</div>
                            </div>
                            <div class="text-center insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5"  >
                                <p ><b>We work to create lasting impact for employees, community and creating a meaningful
                                        culture through meetups.</b> <br> <b>We strive to not only achieve business success but also
                                        contribute positively to society and the environment.</b>
                                </p>
                            </div>
                        </div>
                      
                       
                            <div class="row container justify-content-center">
                                <ng-container *ngFor="let event of pastEvents">
                                    <div class="col-lg-4 col-md-6 col-sm-12">
                                        <div class="projects-wrap style-01">
                                            <div class="projects-image-box">
                                                <div class="projects-image">
                                                   
                                                    <img [src]="getImageUrl(event.bannerImage)" class="h-100 w-100"
                                                        alt="event image">
                                                </div>
                                                <div class="events-content">
                                                    <h4> <a [routerLink]="['/single-event', event.id]">{{event.name}} </a>
                                                    </h4>
                                                   
                                                    <p class="casestudy-card-text global_section_contents border-bottom ">{{ event.topic
                                                    }}</p>
                                                    <div _ngcontent-tfy-c62="" class="cmp-events-promo__event-date justify-content-between">
                                                       
                                                        <span _ngcontent-tfy-c62=""
                                                            class="cmp-events-promo__event-day"><i class="fas fa-calendar-alt px-2"></i><b>{{event.startDate|date:
                                                                'longDate'}}</b></span>
                                                           
                                                        <span _ngcontent-tfy-c62=""
                                                            class="cmp-events-promo__event-time"><b>
                                                              
                                                            </b></span>
                                                            <span _ngcontent-tfy-c62=""
                                                            class="cmp-events-promo__event-time "> 
                                                            <span class="badge badge-success " style="border-radius:10px;background-color:#c02b2b;padding: 8px 24px;">Ended</span></span>
                                                    </div>
                                                    <div class="event-para">
                                                    </div>
                                                    <a [routerLink]="['/event-details', event.id]"  class="global_button text-center  btn-lg white_button" style="   
                                                    color: white;
                                                    border: none !important;
                                                    background: linear-gradient(45deg, #061567, #6186c9) !important;">
                                                        <div class="dub-arrow">
                                                            <img src="../../../assets/images/button/arrowWhite.png" alt="banners" />
                                                        </div>
                                                       View Details
                                                    </a>
                                                </div>
                                               
                                              
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                </div>
                            </div>
                    </div>
                </div>
            </div>
        </div>
    <!-- </div> -->
</section>
<!--====== Our-Activity section  End ======-->



<!-- <!========== Upcoming Events section start ======>  -->
<section>
  
    <div id="main-wrapper" *ngIf="isUpcomingExits">
        <div class="site-wrapper-reveal">
            <div class="projects-wrapper projects-masonary-wrapper">
                <div class="events">
                    <div class="container-fluid">
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="section-title-wrap text-center section-space--mb_40">
                                    <div class="text-center application_content_service global_section_header mt-5">
                                        Upcoming Events</div>
                                        <div class="text-center insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5">We're always working on putting great events together.
                                            Be sure to check back soon for more event listings.</div>
                                </div>
                            
                            </div>
                        </div>
                        

                            <div class="container">
                                <div class="row justify-content-center">
                                <ng-container *ngFor="let event of upcomingEvents">
                                    <div *ngIf="event" class="col-lg-4 col-md-6 col-sm-12">
                                        <div class="projects-wrap style-01">
                                            <div class="projects-image-box">
                                                <div class="projects-image">
                                                    <div class="cmp-events-promo__image__event-date-month">
                                                        <span class="cmp-events-promo__image__event-date bg-white" style="color: blueviolet; font-weight: bold;">{{ event.meetupType ? 'Virtual' : 'In-Person' }}</span>
                                                      
                                                    </div>
                                                    <img [src]="getImageUrl(event.bannerImage)" class=" h-100 w-100" alt="event image">
                                                </div>
                                                <div class="events-content">
                                                    <h4>
                                                        <a [routerLink]="['/event-details', event.id]">{{event.name}}</a>
                                                    </h4>
                                                  
                                                    <p class="casestudy-card-text global_section_contents border-bottom">{{ event.topic }}</p>
                                                    <div class="d-flex justify-content-between align-items-center cmp-events-promo__event-date">
                                                        <span class="cmp-events-promo__event-day">
                                                            <i class="fas fa-calendar-alt px-2"></i>
                                                            <b>{{event.startDate | date: 'longDate'}}</b>
                                                        </span>
                                                        <span class="cmp-events-promo__event-time">
                                                            <i class="fa-solid fa-clock fa-flip-horizontal px-2"></i>
                                                            <b>{{event.startDate | date: 'shortTime'}}</b>
                                                        </span>
                                                        <span class="badge badge-success p-2 px-3" style="border-radius: 10px; background-color: green;">Upcoming</span>
                                                    </div>
                                                    <div class="event-para"></div>
                                                    <a [routerLink]="['/event-details', event.id]"  class="global_button text-center  btn-lg white_button" style="   
                                                    color: white;
                                                    border: none !important;
                                                    background: linear-gradient(45deg, #061567, #6186c9) !important;">
                                                        <div class="dub-arrow">
                                                            <img src="../../../assets/images/button/arrowWhite.png" alt="arrowWhite" />
                                                        </div>
                                                       Register Now
                                                    </a>
                                                 
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </ng-container>
                                </div>
                            </div>
                            
                    </div>


                </div>
            </div>
        </div>
    </div>
</section>

<!-- <!========== Upcoming Events section end ======> -->

<div class="modal" id="myModal03">
    <div class="modal-dialog modal-lg">
        <div class="modal-content">
            <div class="modal-header">
                <div class="career-modal global_sub_title mx-5 ">Business Analyst</div>
            </div>
            <div class="modal-body">
                <div class='page-meta career_popupcontent'>
                    <div class='row'>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>Location:</span> &nbsp; Waterbury - USA</div>
                        </div>
                        <div class='col-xs-12 col-sm-2 py-0  w-20'>
                            <div><span class='c-orange job-career-title'>Job Type:</span> &nbsp; Full time</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0 w-30'>
                            <div><span class='c-orange job-career-title'>Open Date:</span> &nbsp; December 01,2023</div>
                        </div>
                        <div class='col-xs-12 col-sm-3 py-0'>
                            <div><span class='c-orange job-career-title'>End Date:</span> &nbsp; &nbsp; January 05,2024
                            </div>
                        </div>
                    </div>
                </div>
                <hr />
                <div class="career_popupcontent">Maganti IT Resources LLC is seeking one professional for the full-time
                    position of a Business Analyst.</div>
                <div class="global_sub_title job-description mt-4"><b>Job duties</b></div>
                <div class="career_popupcontent">
                    Conduct organizational studies and evaluations, design systems and procedures, conduct work
                    simplification, measurement studies; prepare operations and procedures manuals to assist management
                    in operating more efficiently and effectively; identify and analyze data gathered and develop
                    solutions or alternative methods of the proceeding; determine techniques through requirements
                    gathering for problem-solving and deliver the business objectives.

                </div>
                <div class="global_sub_title job-description  mt-4"><b>Education Required</b></div>
                <div class="career_popupcontent">The minimum educational qualification for this position is a Master of
                    Business Administration or related field.</div>

                <div class="global_sub_title job-description  mt-4"><b>Please send your resume to</b></div>
                <div class="career_popupcontent">hr&#64;mitresource.com</div>
            </div>
            <div class="modal-footer">
                <button type="button" class="modal_button  btn " data-bs-dismiss="modal">Close</button>
            </div>
        </div>
    </div>
</div>


<section class="testimonials">
    <div class="container">
        <div class="row">
            <div class="text-center application_content_service global_section_header mt-5">Attendee Voices: Dive into Their Stories.</div>
            <div class="text-center insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5">
                <p><b>Let's take a moment to explore how our events have truly been <br> transformative for numerous individuals. It's quite the story!</b></p>
            </div>
            <div class="col-sm-12">
                <div id="customers-testimonials" class="owl-carousel">

                    <!--TESTIMONIAL 1 -->
                    <div class="item">
                        <div class="shadow-effect">
                            <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img.webp" alt="quote" >
                            <p style="color: white"> The meetup was a total game-changer, bringing together so many different people to light up some really cool ideas. - Ravi Sharma.</p>
                        </div>
                        <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img-1.webp" alt="person_profile" class="testimonials_persion_profile">
                    </div>
                    <!--END OF TESTIMONIAL 1 -->
 
 
                    <!--TESTIMONIAL 2 -->
                    <div class="item">
                        <div class="shadow-effect">
                            <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img.webp" alt="quote">
                            <p style="color: white;" class="Test_2">Wow, that meetup was something else! Made some awesome connections and got my brain buzzing with possibilities for working together. -Jenny Martin.</p>
                        </div>
                        <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img-3.webp" alt="person_profile" class="testimonials_persion_profile">
                    </div>
                    <!--END OF TESTIMONIAL 2 -->
 
 
                    <!--TESTIMONIAL 3 -->
                    <div class="item">
                        <div class="shadow-effect">
                            <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img.webp" alt="quote">
                            <p style="color: white">Unexpectedly impactful, the meetup not only exceeded my expectations but also paved the way for future collaborations. -Aakash</p>
                        </div>
                        <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img-2.webp" alt="person_profile" class="testimonials_persion_profile">                    
                    </div>
                    <!--END OF TESTIMONIAL 3 -->
                    <div class="item">
                        <div class="shadow-effect">
                            <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img.webp" alt="quote">
                            <p style="color: white">Unexpectedly impactful, the meetup not only exceeded my expectations but also paved the way for future collaborations. -Aakash</p>
                        </div>
                        <img src="../../../assets/images/mit-eventspage/AttendeeVoices-img-2.webp" alt="quote" style="margin-top: -30px;">                    </div>
                    <!--END OF TESTIMONIAL 3 -->
 
 
                </div>
            </div>
        </div>
    </div>

    <!-- END OF TESTIMONIALS -->
</section>




<!-- ======= Image Gallery section start ======-->
<section>
    <div class="gallery-container-fluid">
        <div class="row">
            <div class="col-md-12">
                <div class="text-center application_content_service global_section_header mt-2">Gallery</div>
                <div class="insights-subtitle global_sub_titles casestudy-subtitle my-3 my-lg-5 text-center">
                    <p><b>Get in on the excitement! Here's a quick peek at the fun and lively moments from our recent
                            events.</b></p>
                </div>

                <main class="gallery">
                    <figure>
                        <img src="../../../assets/images/mit-eventspage/Image-gallery-new-1.jpg"
                            class="single-gallery__thum bg-item-images galleryImg bg-img" alt="r&d finance" />
                    </figure>

                    <figure>
                        <img src="../../../assets/images/mit-eventspage/Image-gallery-new-2.jpg"
                            class="single-gallery__thum bg-item-images galleryImg bg-img" alt="r&d finance" />
                    </figure>

                    <figure>
                        <img src="../../../assets/images/mit-eventspage/Image-gallery-new-3.jpg"
                            class="single-gallery__thum bg-item-images galleryImg bg-img" alt="r&d finance" />
                    </figure>

                    <figure>
                        <img src="../../../assets/images/mit-eventspage/Group-Photo-1.jpg"
                            class="single-gallery__thum bg-item-images galleryImg bg-img" alt="r&d finance" />
                    </figure>

                    <figure>
                        <img src="../../../assets/images/mit-eventspage/Image-gallery-new-5.jpg"
                            class="single-gallery__thum bg-item-images galleryImg bg-img" alt="r&d finance" />
                    </figure>

                    <figure>
                        <img src="../../../assets/images/mit-eventspage/Diwali-Pic.jpg"
                            class="single-gallery__thum bg-item-images  galleryImg bg-img" alt="r&d finance" />
                    </figure>
                </main>


            </div>
        </div>
    </div>
</section>
<!-- ======= Image Gallery section end ======-->


<!-- ===================== Stay Informed section starts =============== -->


  <app-eventfooter></app-eventfooter>
   